import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineGameType";

const url = "/api/machines/MachineGameType";

export const machineGameTypeLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Game Type",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
